import type {SxProps} from '@mui/material';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import {lighten} from '@mui/system/colorManipulator';
import type {ElementType, FC, ReactNode} from 'react';
import {primaryColor} from '@/theme/theme';

//TYPES
type Props = {
  direction?: 'column' | 'row';
  value: string;
  width?: string;
  icon: ElementType;
  required?: boolean;
  children?: ReactNode;
};

const LabelChip: FC<Props> = ({direction = 'row', value, icon: Icon, children, required = false, width = '175px'}) => {
  return (
    <Stack direction={direction} sx={styles(width).container} spacing={1}>
      <Stack direction="row" spacing={1} sx={styles(width).chip}>
        <Icon sx={styles(width).icon} />
        <Typography variant="overline" sx={styles(width).label}>
          {value} {required && '*'}
        </Typography>
      </Stack>
      {children}
    </Stack>
  );
};

export default LabelChip;

const styles = (width: string): Record<string, SxProps> => ({
  container: {
    display: 'flex',
    width: '100%',
    alignItems: 'flex-start',
  },
  label: {
    ml: 0.5,
    color: 'primary.main',
    fontWeight: 'bold',
  },
  chip: {
    alignItems: 'center',
    bgcolor: lighten(primaryColor, 0.95),
    width: 'fit-content',
    minWidth: width,
    pr: 1,
  },
  icon: {
    color: 'primary.dark',
    bgcolor: lighten(primaryColor, 0.8),
    width: '36px',
    height: '36px',
    m: 0,
    p: 0.75,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
});
